import { SeriesColumnOptions, SeriesLineOptions } from 'highcharts'
import React, { FC, memo } from 'react'

import { ChartLine, LoadingIndicator } from 'Components'
import { DebugPanel } from 'Components/Debug'
import { colors } from 'Config'
import { EnergyHistoryChartData } from 'Models'

interface Props {
  energyHistoryChartData: EnergyHistoryChartData
  programStartDates?: Array<{ value: number }>
  loading?: boolean
}

const EnergyHistory: FC<Props> = ({ energyHistoryChartData, programStartDates, loading = false }: Props) => {
  const hasChart = !!energyHistoryChartData.accepted?.length && !!energyHistoryChartData.goal?.length

  if (!hasChart && !loading) {
    return null
  }

  return (
    <>
      {hasChart && (
        <DebugPanel>
          <code>{JSON.stringify({ energyHistoryChartData, programStartDates }, null, 2)}</code>
        </DebugPanel>
      )}
      <div className="standardcard col-12 pt-3 mx-2">
        {hasChart ? (
          <div style={{ width: '100%', flex: '0 0 100%' }}>
            <ChartLine
              dataType="datetime"
              theme="exact"
              series={[
                {
                  type: 'column',
                  color: colors.lineChart.primaryColor,
                  name: 'Kalorien',
                  data: energyHistoryChartData.accepted
                } as SeriesColumnOptions,
                {
                  type: 'line',
                  color: colors.lineChart.goal,
                  marker: {
                    enabled: false
                  },
                  name: 'Ziel',
                  data: energyHistoryChartData.goal
                } as SeriesLineOptions,
                ...([
                  programStartDates
                    ? {
                        // fake series for legend
                        type: 'line',
                        name: 'Programmstart',
                        color: colors.lineChart.programRestart,
                        marker: {
                          enabled: false,
                          fillColor: colors.lineChart.programRestart,
                          lineColor: colors.lineChart.programRestart
                        },
                        data: []
                      }
                    : []
                ] as SeriesLineOptions[])
              ]}
              xAxisPlotLines={
                programStartDates &&
                programStartDates.map((program) => ({
                  ...program,
                  color: colors.lineChart.programRestart,
                  width: 1
                }))
              }
            />
          </div>
        ) : (
          <div style={{ minHeight: '20rem', width: '100%' }} />
        )}
        {loading && (
          <div className="panel-loading-overlay">
            <LoadingIndicator />
          </div>
        )}
      </div>
    </>
  )
}

export default memo(EnergyHistory)
